import React from 'react';
import { Code2, Music } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer id="about" className="px-6 py-16 border-t border-white/[0.04]">
      <div className="max-w-6xl mx-auto">
        {/* Top section */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-16 h-16 flex items-center justify-center">
                <img src="/tabla-logo-v2.png" alt="Riyaz Tools Logo" className="w-full h-full object-contain" />
              </div>
              <span className="text-lg font-semibold text-white">Riyaz Tools</span>
            </div>
            <p className="text-sm text-neutral-500 leading-relaxed">
              Precision-engineered digital instruments for Indian Classical Music practitioners.
              Built with the Web Audio API.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-xs font-mono text-neutral-400 tracking-widest uppercase mb-4">Links</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://manmitsinghmusic.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm text-neutral-400 hover:text-gold transition-colors"
                >
                  <Music className="w-3.5 h-3.5" />
                  Musician Portfolio
                </a>
              </li>

              <li>
                <a
                  href="https://github.com/manmit97"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm text-neutral-400 hover:text-gold transition-colors"
                >
                  <Code2 className="w-3.5 h-3.5" />
                  GitHub
                </a>
              </li>
            </ul>
          </div>

          {/* Tech */}
          <div>
            <h4 className="text-xs font-mono text-neutral-400 tracking-widest uppercase mb-4">Built With</h4>
            <div className="flex flex-wrap gap-2">
              {['React', 'TypeScript', 'Tailwind CSS', 'Web Audio API', 'Tone.js'].map((tech) => (
                <span key={tech} className="tech-badge">
                  {tech}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-white/[0.04] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-neutral-600">
            © {new Date().getFullYear()} Manmit Singh. All rights reserved.
          </p>
          <p className="text-xs text-neutral-600 font-mono">
            Handcrafted with precision in Melbourne, Australia
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
